import { useMemo } from 'react';
import { useEventListForCreateMetric } from '../../api/queryHooks';
import { buildEventByRawEvent } from 'emp-3.0/utils';

export const useGetEventByIdOrName = (eventId: string) => {
  const { data = [] } = useEventListForCreateMetric();
  return useMemo(() => {
    if (!eventId) return null;
    const event = data.find((e) => e.event_id === eventId || e.event_name === eventId);
    // raw event
    if (event?.is_raw) {
      return buildEventByRawEvent(event.event_name);
    }
    return event;
  }, [eventId, data]);
};
